import { Spin } from 'antd'
import { Moment } from 'moment'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { TitleSearch } from '@/components/pages/ClientDevice/styles'
import { dateTime } from '@/configs'
import routes from '@/constants/routes'
import { useAttendance } from '@/pages/Attendance/Attendance.hooks'
import { formatDateSendRequest } from '@/utils/date'

import {
  AttendanceErrorWrapper,
  DataCellWrapper,
  DatePickerCustom,
  HeaderCellWrapper,
  Icon,
  PageHeaderCustom,
  RangeDateWrapper,
  SearchDayWrapper,
  TableCustom,
  TableWrapper,
} from './styles'

type FilterErrorAttendance = {
  fromDate: Moment | null
  toDate: Moment | null
}

const defaultFilterDate = {
  fromDate: null,
  toDate: null,
}

const Home = () => {
  const { t } = useTranslation()
  const { getAttendanceErrorResponse, getErrorByRangeDay, attendanceErrorLoading } = useAttendance()

  const [dateRangeFilter, setDateRangeFilter] = useState<FilterErrorAttendance>(defaultFilterDate)

  const handlePickRangeDay = (type: string, date: Moment | null) => {
    switch (type) {
      case 'fromByRangeDate':
        setDateRangeFilter((pre) => ({ ...pre, fromDate: date }))
        date &&
          dateRangeFilter.toDate &&
          getErrorByRangeDay({
            fromDate: formatDateSendRequest(date),
            toDate: formatDateSendRequest(dateRangeFilter.toDate),
          })
        break

      case 'toByRangeDate':
        setDateRangeFilter((pre) => ({ ...pre, toDate: date }))
        getErrorByRangeDay({
          fromDate: formatDateSendRequest(dateRangeFilter.fromDate),
          toDate: formatDateSendRequest(date),
        })
        break

      default:
        break
    }
  }

  useEffect(() => {
    if (!dateRangeFilter.fromDate || !dateRangeFilter.toDate) {
      const currentDate = moment()
      const agoDay = currentDate.clone().subtract(7, 'days')
      getErrorByRangeDay({
        fromDate: formatDateSendRequest(agoDay),
        toDate: formatDateSendRequest(currentDate),
      })
    }
  }, [dateRangeFilter, getErrorByRangeDay])

  return (
    <AttendanceErrorWrapper>
      <PageHeaderCustom ghost={false} title={t('components.pages.attendance.pageHeader.titleError')} />
      <SearchDayWrapper>
        <TitleSearch width="30%">{t('components.pages.attendance.table.date')}</TitleSearch>
        <RangeDateWrapper>
          <DatePickerCustom
            value={dateRangeFilter.fromDate}
            onChange={(date) => handlePickRangeDay('fromByRangeDate', date)}
            format={dateTime.dateFormat}
          />
          <Icon>~</Icon>
          <DatePickerCustom
            value={dateRangeFilter.toDate}
            onChange={(date) => handlePickRangeDay('toByRangeDate', date)}
            format={dateTime.dateFormat}
          />
        </RangeDateWrapper>
      </SearchDayWrapper>
      <Spin spinning={attendanceErrorLoading}>
        <TableWrapper>
          <TableCustom>
            <tbody>
              <tr>
                <HeaderCellWrapper className="fixed">
                  {t('components.pages.attendanceEmployee.listReport.table.date')}
                </HeaderCellWrapper>
                {getAttendanceErrorResponse.map((error, index) => (
                  <HeaderCellWrapper key={index}>
                    <Link to={`${routes.attendance.path}?filterDay=${error.date}`} target="_blank">
                      {error.date}
                    </Link>
                  </HeaderCellWrapper>
                ))}
              </tr>
            </tbody>
            <DataCellWrapper position="center" className="fixed">
              {t('components.pages.attendance.table.totalError')}
            </DataCellWrapper>
            {getAttendanceErrorResponse.map((error, index) => (
              <DataCellWrapper key={index}>{error.count}</DataCellWrapper>
            ))}
          </TableCustom>
        </TableWrapper>
      </Spin>
    </AttendanceErrorWrapper>
  )
}

Home.displayName = 'Home'
export default Home
